import React, { useState, useEffect } from 'react'

interface SafeImagePropsInterface extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string
}

const SafeImage: React.FC<SafeImagePropsInterface> = ({
  src,
  alt,
  className,
  fallbackSrc = '/img/default-placeholder.svg', // Default placeholder if not provided
  ...props
}) => {
  const [imgSrc, setImgSrc] = useState<string>(fallbackSrc)
  // Check env var. Note: env vars are strings, so "false" string evaluates to true
  const isImageDisabled = import.meta.env.VITE_DISABLE_IMAGE_PROCESSING === 'true'

  useEffect(() => {
    if (isImageDisabled) {
      setImgSrc(fallbackSrc)
    } else if (src && src !== '') {
      setImgSrc(src)
    } else {
      setImgSrc(fallbackSrc)
    }
  }, [src, isImageDisabled, fallbackSrc])

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    // Prevent infinite loop if fallback also fails
    const target = e.target as HTMLImageElement
    if (target.src !== window.location.origin + fallbackSrc) {
      setImgSrc(fallbackSrc)
    }
  }

  return <img {...props} src={imgSrc} alt={alt} className={className} onError={handleError} />
}

export default SafeImage
